import React from 'react';
import { AppName } from 'sl-api-connector';
import {
  AdManagerLogo,
  AdvisorLogo,
  AtlasLogo,
  BeaconLogo,
  DiscoverLogo,
  OmniLogo,
  SvgElementProps
} from 'src/components/SvgIcons/SvgIcons';
import { getAppName } from 'src/utils/app';

const LogoIcon = (props: SvgElementProps) => {
  const appName = getAppName();

  let LogoIconComponent = AdvisorLogo;
  if (appName === AppName.Atlas) {
    LogoIconComponent = AtlasLogo;
  } else if (appName === 'Advisor') {
    LogoIconComponent = AdvisorLogo;
  } else if (appName === AppName.Omni) {
    LogoIconComponent = OmniLogo;
  } else if (appName === AppName.Beacon) {
    LogoIconComponent = BeaconLogo;
  } else if (appName === AppName.Discover) {
    LogoIconComponent = DiscoverLogo;
  } else {
    LogoIconComponent = AdManagerLogo;
  }

  return <LogoIconComponent {...props} />;
};

export default LogoIcon;
